<template>
  <div class="popover" v-bind="$attrs" v-on-click-outside="handleClickOutside">
    <info-tooltip :show-icon="false" :position="position" :side="side">
      <template #tooltip-trigger>
        <div @click="toggleVisible">
          <slot />
        </div>
      </template>
      <div class="content" v-if="isOpen">
        <slot name="content" />
      </div>
    </info-tooltip>
  </div>
</template>

<script>
import InfoTooltip from '@ui-kit/components/tooltips/InfoTooltip.vue';
import { vOnClickOutside as onClickOutside } from '@vueuse/components';

export default {
  components: {
    InfoTooltip,
  },
  directives: { onClickOutside },
  props: {
    position: {
      type: String,
      default: 'center'
    },
    side: {
      type: String,
      default: 'bottom'
    },
    disabled: {
      type: Boolean,
    },
    open: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    handleClickOutside() {
      this.isOpen = false;
      this.$emit('update:open', false);
    },
    toggleVisible() {
      if (this.disabled) return;

      this.isOpen = !this.isOpen;
      this.$emit('update:open', !this.open);
    },
  },
  watch: {
    open(newValue) {
      if (newValue !== this.isOpen) this.isOpen = newValue;
    }
  }
};
</script>

<style lang="scss" scoped>
.popover::v-deep {
  position: relative;
  .info-content-box {
    margin-top: 0.8rem;
    max-width: unset;
  }
  .info-tooltip-container {
    height: auto;
  }
}
</style>
